<template>
  <commonQueryInput
    :inputItems="multiInputItems"
    v-model:getValue="multiInputVal"
  ></commonQueryInput>
  <div class="text-end" style="margin-bottom: 0.6rem">
    <exportCsv
      :exportData="exportData"
      :exportDataTitle="maintenanceHistoryTableFields.map((item) => item.label)"
      :exportFileName="'維修履歷_' + deviceName + '_' + queryDate"
    />
  </div>
  <commonTable
    :fields="maintenanceHistoryTableFields"
    :items="maintenanceHistoryTableItems"
    :rowClick="maintenanceHistoryRowClick"
    :theme="'green'"
    stickyHeader="550px"
  >
    <template #cell(device)="data">
      <template v-if="data.item.category == 3">
        <div style="color: red">{{ data.value }}</div></template
      >
      <template v-else>
        {{ data.value }}
      </template>
    </template>
    <template #cell(startTime)="data">
      <template v-if="data.item.category == 3">
        <div style="color: red">{{ data.value }}</div></template
      >
      <template v-else>
        {{ data.value }}
      </template>
    </template>
    <template #cell(endTime)="data">
      <template v-if="data.item.category == 3">
        <div style="color: red">{{ data.value }}</div></template
      >
      <template v-else>
        {{ data.value }}
      </template>
    </template>
    <template #cell(category)="data">
      <template v-if="data.value == 3">
        <div style="color: red">搶修</div></template
      >
      <template v-else>報修</template>
    </template>
    <template #cell(description)="data">
      <template v-if="data.item.category == 3">
        <div style="color: red">{{ data.value }}</div></template
      >
      <template v-else>
        {{ data.value }}
      </template>
    </template>
    <template #cell(personnel)="data">
      <template v-if="data.item.category == 3">
        <div style="color: red">{{ data.value }}</div></template
      >
      <template v-else>
        {{ data.value }}
      </template>
    </template>
    <template #cell(totalTime)="data">
      <template v-if="data.item.category == 3">
        <div style="color: red">{{ data.value }}</div></template
      >
      <template v-else>
        {{ data.value }}
      </template>
    </template>
  </commonTable>
</template>

<script>
import commonQueryInput from "@/components/commonQueryInput.vue";
import exportCsv from "@/components/exportCsv.vue";
import commonTable from "@/components/commonTable.vue";
import { computed, inject, ref, watch } from "vue";
import store from "@/store";
export default {
  components: {
    commonQueryInput,
    exportCsv,
    commonTable,
  },
  setup() {
    const commonMethods = inject("commonMethods");
    const maintenanceHistoryTableFields = inject(
      "maintenanceHistoryTableFields"
    );
    const maintenanceHistoryTableItems = inject("maintenanceHistoryTableItems");
    const queryDate = inject("queryDate");
    const deviceName = inject("deviceName");
    const exportData = inject("exportData");

    const oper = computed(() => store.getters["selectOptions/get_oper"]);
    const device = computed(() => store.getters["selectOptions/get_device"]);

    const multiInputVal = ref();
    const multiInputItems = ref([
      {
        key: "date",
        label: "日期",
        type: "dateBetween", // date/dateBetween/text/select/
      },
      {
        key: "oper",
        label: "站別",
        type: "select",
        checkEmpty: true,
        disableText: "-- 選擇站別 --",
        options: oper,
      },
      {
        key: "deviceID",
        label: "機台",
        type: "select",
        bindKey: "oper",
        checkEmpty: true,
        disableText: "-- 選擇機台 --",
        bindOptions: device,
      },
      {
        key: "category",
        label: "維修別",
        type: "select",
        // checkEmpty: true,
        disableText: "-- 選擇類別 --",
        options: [
          { text: "報修", value: 2 },
          { text: "搶修", value: 3 },
        ],
      },
      {
        key: "keyWords",
        label: "關鍵字",
        type: "text",
        // checkEmpty: true,
      },
    ]);
    watch(
      multiInputVal,
      (newValue) => {
        queryMaintenanceHistory(newValue);
      },
      { deep: true }
    );

    const maintenanceHistoryRowClick = commonMethods.maintenanceHistoryRowClick;
    const queryMaintenanceHistory = commonMethods.queryMaintenanceHistory;

    return {
      multiInputVal,
      multiInputItems,
      maintenanceHistoryTableFields,
      maintenanceHistoryTableItems,
      maintenanceHistoryRowClick,
      queryDate,
      deviceName,
      exportData,
    };
  },
};
</script>

<style></style>
